/**
 * Аналитические отчеты. Модуль для работы с API
 * @module analyticReports
 */

/**
 * Получение списка аналитических отчетов.
 * @param {Object} params - Параметры запроса
 * @returns {Promise} - список
 * @throws {Error} - ошибка при получении данных
 */
export const getList = async (params) => {
  try {
    const response = await fetch(`/api/analyticreports?`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
      );
    }

    return data.reports;
  } catch (err) {
    throw err;
  }
};

/**
 * Создание аналитического отчета
 * @param {Object} item - данные
 * @returns {Promise} - созданный элемент
 * @throws {Error} - ошибка при создании данных
 */
export const createItem = async (item) => {
  try {
    const response = await fetch("/api/analyticreport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при создании данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.report;
  } catch (err) {
    throw err;
  }
};

/**
 * Обновление аналитического отчета
 * @param {Object} item - данные статуса
 * @returns {Promise} - обновленный статус
 * @throws {Error} - ошибка при обновлении данных
 */
export const updateItem = async (item) => {
  try {
    const response = await fetch("/api/analyticreport", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при обновлении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.report;
  } catch (err) {
    throw err;
  }
};

/**
 * Удаление аналитического отчета
 * @param {Object} item - данные
 * @returns {Promise} - удаленный элемент
 * @throws {Error} - ошибка при удалении данных
 */
export const deleteItem = async (item) => {
  try {
    const response = await fetch("/api/analyticreport", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(
        `Ошибка при удалении данных. ${data.error || "Попробуйте снова"}`
      );
    }

    return data.report;
  } catch (err) {
    throw err;
  }
};
